class BundleDealsComponent extends HTMLElement {
  connectedCallback() {
    this.#bindOptions();
    this.#listenForVariantUpdates();
    const first = this.querySelector('.bundle-deals__option');
    if (first) this.#selectOption(first);
  }

  #bindOptions() {
    this.querySelectorAll('.bundle-deals__option').forEach((option) => {
      option.addEventListener('click', () => this.#selectOption(option));
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.#selectOption(option);
        }
      });
    });
  }

  #selectOption(selected) {
    this.querySelectorAll('.bundle-deals__option').forEach((opt) => {
      opt.classList.toggle('bundle-deals__option--selected', opt === selected);
      opt.setAttribute('aria-checked', opt === selected ? 'true' : 'false');
    });

    const totalQty = parseInt(selected.dataset.bundleTotal, 10) || 1;
    const buyQty = parseInt(selected.dataset.bundleBuy, 10) || 1;
    const freeQty = parseInt(selected.dataset.bundleFree, 10) || 0;

    this.#updateQuantity(totalQty);
    this.#updateBundleProperty(freeQty > 0 ? `${buyQty}+${freeQty}` : '');
    document.dispatchEvent(new CustomEvent('bundle:select', { detail: { totalQty } }));
  }

  #updateQuantity(totalQty) {
    const inner = this.querySelector('.bundle-deals');
    const sectionId = this.dataset.sectionId || inner?.dataset.sectionId;
    const form = document.getElementById(`BuyButtons-ProductForm-${sectionId}`);
    if (!form) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = totalQty;
    }

    const productFormComponent = form.closest('product-form-component');
    const qsComponent = productFormComponent?.querySelector('quantity-selector-component');
    if (qsComponent) {
      if (typeof qsComponent.setValue === 'function') {
        qsComponent.setValue(String(totalQty));
      }
      const qsInput = qsComponent.querySelector('input[ref="quantityInput"]');
      if (qsInput) {
        qsInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (typeof qsComponent.updateButtonStates === 'function') {
        qsComponent.updateButtonStates();
      }
    }
  }

  #updateBundleProperty(bundleValue) {
    const inner = this.querySelector('.bundle-deals');
    const blockId = this.dataset.blockId || inner?.dataset.blockId;
    const propertyInput = document.querySelector(`[data-bundle-deals-property="${blockId}"]`);
    if (propertyInput) {
      propertyInput.value = bundleValue;
    }
  }

  #formatMoney(cents) {
    const format = this.dataset.moneyFormat || '{{ amount }}';
    const amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
  }

  #listenForVariantUpdates() {
    const section = this.closest('.shopify-section') || document;

    section.addEventListener('variant:update', (event) => {
      const newPrice = parseInt(event.detail?.resource?.price, 10);
      if (Number.isNaN(newPrice)) return;

      this.dataset.variantPrice = newPrice;

      this.querySelectorAll('.bundle-deals__option').forEach((opt) => {
        const buyQty = parseInt(opt.dataset.bundleBuy, 10) || 1;
        const freeQty = parseInt(opt.dataset.bundleFree, 10) || 0;
        const totalQty = parseInt(opt.dataset.bundleTotal, 10) || 1;

        const newSavings = newPrice * freeQty;
        const effectivePerItem = Math.round((newPrice * buyQty) / totalQty);

        opt.dataset.bundleSavingsCents = newSavings;

        const savingsEl = opt.querySelector('.bundle-deals__savings');
        if (savingsEl) {
          savingsEl.textContent = freeQty > 0
            ? (this.dataset.saveText || 'Save __AMOUNT__').replace('__AMOUNT__', this.#formatMoney(newSavings))
            : '';
        }

        const perItemEl = opt.querySelector('.bundle-deals__per-item');
        if (perItemEl) {
          perItemEl.textContent = `${this.#formatMoney(effectivePerItem)} ${this.dataset.perItemText || 'per item'}`;
        }
      });
    });
  }
}

if (!customElements.get('bundle-deals-component')) {
  customElements.define('bundle-deals-component', BundleDealsComponent);
}
